import { signupInitialState, signupReducer } from './signup';
import {
  waitingScreenInitialState,
  waitingScreenReducer,
} from './waitingScreen';
import {
  timeoutScreenInitialState,
  timeoutScreenReducer,
} from './timeoutScreen';

export const mainReducer = (
  { signup, waitingScreen, timeoutScreen },
  action,
) => {
  return {
    signup: signupReducer(signup, action),
    waitingScreen: waitingScreenReducer(waitingScreen, action),
    timeoutScreen: timeoutScreenReducer(timeoutScreen, action),
  };
};

export const mainInitialState = {
  signup: signupInitialState,
  waitingScreen: waitingScreenInitialState,
  timeoutScreen: timeoutScreenInitialState,
};
